import toastr from "toastr";

const DEFAULT_CONFIG = {
  tapToDismiss: true,
  toastClass: "toast",
  containerId: "toast-container",
  debug: false,
  showMethod: "slideDown", // fadeIn, slideDown, and show are built into jQuery
  showDuration: 500,
  showEasing: "swing", // swing and linear are built into jQuery
  onShown: undefined,
  hideMethod: "slideUp",
  hideDuration: 500,
  hideEasing: "swing",
  onHidden: undefined,
  closeMethod: false,
  closeDuration: false,
  closeEasing: false,
  closeOnHover: false,
  closeButton: true,
  extendedTimeOut: 1000,
  iconClasses: {
    error: "toast-error",
    info: "toast-info",
    success: "toast-success",
    warning: "toast-warning",
  },
  positionClass: "toast-top-full-width",
  timeOut: 10000, // Set timeOut and extendedTimeOut to 0 to make it sticky
  titleClass: "toast-title",
  messageClass: "toast-message",
  escapeHtml: false,
  target: "body",
  closeHtml: "<button type='button'>&times;</button>",
  closeClass: "toast-close-button",
  newestOnTop: true,
  preventDuplicates: true,
  progressBar: false,
  progressClass: "toast-progress",
  rtl: false,
};

const TOAST_TYPES = {
  success: "success",
  warning: "warning",
  info: "info",
  error: "error",
};

const { info, success, error } = TOAST_TYPES;

const DEFAULT_MESSAGE = "There was a problem with the request. Please try again after some time.";

export const PERSISTING_FLASH_CONFIG = { timeOut: 0, extendedTimeOut: 0 };

export const showToast = (type = info, msg = DEFAULT_MESSAGE, title = "", options = null) => {
  if (typeof window === "undefined") {
    switch (type) {
      case "error":
        // eslint-disable-next-line no-console
        console.error(msg);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log(msg);
    }
    return;
  }
  const config = options ? { ...DEFAULT_CONFIG, ...options } : DEFAULT_CONFIG;
  toastr[type](msg, title, config);
};

export const clearToasts = () => toastr.clear();

export const showError = (...params) => showToast(error, ...params);

export const showSuccess = (...params) => showToast(success, ...params);
